import { render } from "./contractInfo.vue?vue&type=template&id=a4dce36a&scoped=true"
import script from "./contractInfo.vue?vue&type=script&lang=js"
export * from "./contractInfo.vue?vue&type=script&lang=js"

import "./contractInfo.vue?vue&type=style&index=0&id=a4dce36a&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4dce36a"]])

export default __exports__